module.exports = __webpack_public_path__ + "img/setting_2.b4e50bef.svg";